<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="mt-6">
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">ดาวน์โหลดไฟล์สำเร็จ !</v-alert>
          <v-alert type="success" class="alert" v-if="alert_close === true">ปิดรอบสำเร็จ !</v-alert>
        </v-slide-x-reverse-transition>
        <v-card elevation="6">
          <div class="pa-4">
            <span style="font-size: 24px">ประวัติการนับสต๊อก</span>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="CountHeader" :items="stock_list" :footer-props="footer_Props" :items-per-page.sync="item_page" :search="search" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>รอบนับครั้งที่ {{ dataDetail.item.stock_name }}</td>
                  <td>{{ diffDate(dataDetail.item.count_date) }}</td>
                  <td>
                    <div v-if="dataDetail.item.stock_note !== null">{{ dataDetail.item.stock_note }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>{{ dataDetail.item.username }}</td>
                  <td class="pa-3">
                    <div v-if="dataDetail.item.stock_status == 2">
                      <v-btn small @click="getDetails(dataDetail.item.stock_id)" class="pa-6 ma-2 grad-success-bg white--text mr-1" style="font-size: 16px"><v-icon>mdi-magnify</v-icon> ดูรายละเอียด</v-btn>
                      <v-btn small @click="export_file(dataDetail.item.stock_id)" class="pa-6 ma-2 grad-primary-bg white--text mr-1" style="font-size: 16px"><v-icon>mdi-microsoft-excel</v-icon> Export</v-btn>
                    </div>
                    <div v-if="dataDetail.item.stock_status == 0 && $store.state.status == 1">
                      <v-btn small @click="getEdit(dataDetail.item.stock_id)" class="pa-6 ma-2 grad-warning-bg white--text mr-1 text-center" style="font-size: 16px">แก้ไขข้อมูลรอบนับ</v-btn>
                      <v-btn small @click="getClose(dataDetail.item.stock_id, dataDetail.item.stock_name)" class="pa-6 ma-2 grad-danger-bg white--text mr-1 text-center" style="font-size: 16px">ปิดรอบ</v-btn>
                    </div>
                    <div v-else-if="dataDetail.item.stock_status == 1 && $store.state.status == 1">
                      <v-btn small @click="getAudit(dataDetail.item.stock_id)" class="pa-6 ma-2 grad-warning-bg white--text mr-1 text-center" style="font-size: 16px">ตรวจสอบการนับสต๊อก</v-btn>
                    </div>
                    <div v-if="dataDetail.item.stock_status == 0 && $store.state.status == 2 || dataDetail.item.stock_status == 1 && $store.state.status == 2">
                      รอผู้ดูแลระบบทำการปิดรอบก่อนจึงจะสามารถดูข้อมูลได้
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>
      <v-dialog v-model="modal_excel" max-width="400">
        <v-card>
          <v-form ref="add_form" @submit.prevent="">
            <v-card-title>
              เลือกชนิดไฟล์ดาวน์โหลด
            </v-card-title>
            <v-card-text>
              <div class="grid_full">
                <v-autocomplete clearable color="#86bc3a" :items="excel_type" item-text="name" item-value="name" v-model="type" label="รายการ" prepend-inner-icon="mdi-archive" hide-details="auto" outlined></v-autocomplete>
              </div>
            </v-card-text>
            <v-spacer></v-spacer>
            <div class="text-center pa-4">
              <v-btn v-if="type !== null" large class="grad-success-bg white--text mr-3" type="button" style="font-size: 18px" @click="excel_download()">ตกลง</v-btn>
              <v-btn v-else-if="type == null" large class="grad-grey-bg white--text mr-3" type="button" style="font-size: 18px" @click="excel_download()" disabled>ตกลง</v-btn>
              <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="modal_excel = false">ยกเลิก</v-btn>
            </div>
          </v-form>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
import * as XLSX from "xlsx";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Count_list",
  data() {
    return {
      search: '',
      loading_page: false,
      alert_success: false,
      alert_close: false,
      modal_excel: false,
      type: null,
      excel_id: null,
      item_page: -1,
      date_universal: this.dateExport(),
      json: [],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      excel_type: [
        {id: 1, name: '.xls'},
        {id: 2, name: '.xlsx'},
      ],
      CountHeader: [
        {
          text: 'รอบนับ',
          value: 'stock_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'วันที่นับสต๊อก',
          value: 'count_date',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
          sortable: false,
          fixed: true,
          width: '200px',
        },
        {
          text: 'ผู้สร้างรอบนับ',
          value: 'username',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '370px',
        },
      ],
      stock_list: [],
    }
  },
  methods: {
    dateExport() {
      const today = new Date();
      let month = today.getMonth() + 1;
      let date = today.getDate();
      const result_date = date +'_'+month+'_'+(today.getFullYear()+543);
      return result_date;
    },
    diffDate(date) {
      const value = date.split('-')
      const year = parseInt(value[0])
      return value[2]+'/'+value[1]+'/'+(year + 543);
    },
    getDetails(id) {
      this.$router.push('/stock/count_warehouse/warehousedetail/' + id)
    },
    getStock() {
      this.loading_page = true
      HTTP.post('/inventory/counts/stocklists')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.stock_list = res.data.object
            }
          })
    },
    getClose(id, count_number) {
      Swal.fire({
        title: 'คุณต้องการปิดรอบใช่หรือไม่ !',
        text: 'เมื่อคุณปิดรอบนับครั้งที่ '+count_number+' จะไม่สามารถนับสต๊อกของรอบนี้ได้อีก',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_close = true
          HTTP.post('/inventory/counts/changestatus', {
            stock_id: id
          }).then((res) => {
            if (res.data.success === true) {
              setTimeout(() => this.alert_close = false, 3000)
              this.getStock()
            }
          })
        }
      })
    },
    getAudit(id) {
      this.$router.push('/stock/count_warehouse/warehouseclose/' + id)
    },
    getEdit(id) {
      this.$router.push('/stock/count_warehouse/warehouseedit/' + id)
    },
    export_file(id) {
      this.excel_id = id
      this.modal_excel = true
    },
    excel_download() {
      HTTP.post('/inventory/counts/stockexport', {
        stock_id: this.excel_id
      }).then((res) => {
        if (res.data.success === true) {
          res.data.object.forEach((data) => {
            this.json.push({
              'รหัสสินค้า': data.product_code,
              'ชื่อสินค้า': data.product_name,
              'จำนวนคงคลัง': data.quantity,
              'หน่วย': data.unit_name,
              'นับได้': data.quantity_count,
              'ผู้นับสต๊อก': data.user_name,
              'ส่วนต่างก่อนปรับ': data.before_change,
              'ส่วนต่างหลังปรับ': data.confirm_count,
              'ผู้ปรับส่วนต่าง': data.user_confirm_name,
            })
          })
          const dataWS = XLSX.utils.json_to_sheet(this.json)
          const ws_name = 'Sheet1'
          const wscols = [
            { wch: 15 },
            { wch: 49 },
            { wch: 12 },
            { wch: 15 },
            { wch: 12 },
            { wch: 15 },
            { wch: 13 },
            { wch: 13 },
            { wch: 13 },
          ];
          const wb = XLSX.utils.book_new()
          dataWS['!cols'] = wscols;
          XLSX.utils.book_append_sheet(wb, dataWS, ws_name)
          XLSX.writeFile(wb,'stock_'+ this.date_universal + this.type)
          this.modal_excel = false
        }
      })
    }
  },
  mounted() {
    this.getStock();
  }
}
</script>

<style scoped>
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
</style>
